import { SizeUpdater } from "./SizeUpdater";
export async function loadSizeUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("size", () => new SizeUpdater(), refresh);
}
